(ns core.front.admin
  (:require [app.domain.group.model :as group-model]
            [core.front.comm]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::get-authority-groups
  (fn [{:keys [db]} _]
    {:db           (assoc-in db [::data ::loading?] true)
     :comm/command {:command          :admin/get-authority-groups
                    :method           :get
                    :on-success       [::get-authority-groups.success]
                    :finally-dispatch [::get-authority-groups.done]}}))

(rf/reg-event-db ::get-authority-groups.success
  (fn [db [_ _ groups]]
    (assoc-in db [::data ::groups] groups)))

(rf/reg-event-db ::get-authority-groups.done
  (fn [db _]
    (p/dissoc-in db [::data ::loading?])))

(rf/reg-sub ::data :-> ::data)

(rf/reg-sub ::groups
  :<- [::data]
  :-> ::groups)

(rf/reg-sub ::domain-groups
  :<- [::groups]
  (fn [groups]
    (filter group-model/domain? groups)))
